import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";
import Navbar from "../Navbar";
import Footer from "../Footer";
import IP_URL from "../connect";
import { selectUser } from "../../Redux/currentUserSlice";
import useConvertTime from "../../Hooks/ConvertTime";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Page = styled.div`
  font-size: 16px;
  background: #f8faff;
  min-height: 100vh;
`;

const Container = styled.div`
  margin: 30px auto;
  padding: 20px;
  width: 90%;
  max-width: 1150px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  animation: ${fadeIn} 0.6s ease-in-out;
`;

const Header = styled.div`
  text-align: center;
  padding: 25px;
  background: linear-gradient(90deg, #007bff, #00bfff);
  color: white;
  border-radius: 14px;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
`;

const Card = styled.div`
  background: white;
  padding: 22px;
  border-radius: 14px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.6s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.15);
  }
`;

const CardHeader = styled.h3`
  font-size: 18px;
  margin-bottom: 10px;
  color: #007bff;
  text-transform: uppercase;
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #f1f1f1;
`;

const Label = styled.span`
  font-weight: 600;
  color: #333;
`;

const Value = styled.span`
  color: #555;
  word-break: break-all;
`;

const StatusBadge = styled.span`
  padding: 5px 10px;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  background: ${({ status }) =>
    status === "OK"
      ? "#28a745"
      : status === "Error"
      ? "#dc3545"
      : status === "Charging"
      ? "#ffc107"
      : "#6c757d"};
`;

const Section = styled.div`
  text-align: center;
  padding: 10px;
  display: flex;
  justify-content: center;
  gap: 15px;
`;

const OrgButton = styled.button`
  background: #007bff;
  color: white;
  font-weight: 600;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: #0056b3;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.4s ease;
`;

const ModalTitle = styled.h3`
  margin-bottom: 20px;
  text-align: center;
`;

const Dropdown = styled.select`
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 15px;
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  background: ${({ cancel }) => (cancel ? "#6c757d" : "#007bff")};
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  margin-top: ${({ cancel }) => (cancel ? "10px" : "0")};
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: ${({ cancel }) => (cancel ? "#5a6268" : "#0056b3")};
  }
`;

const AdminMeterDetail = () => {
  const { imei } = useParams();
  const [meter, setMeter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [meterDetails, setMeterDetails] = useState('')
  const convertTime = useConvertTime();
  const { token } = useSelector(selectUser);
  const navigate = useNavigate();
const [showEditModal, setShowEditModal] = useState(false);
const [editMeterData, setEditMeterData] = useState({
  meterName: "",
  serialNumber:"",
  MSISDN: "",
  meterType: "",
  meterSize: "",
  permitNo: "",
});

const sizeOptions = ["DN15", "DN20", "DN25", "DN32", "DN40", "DN50", "DN65", "DN80", "DN100", "DN150", "DN200", "DN300"];
const typeOptions = ["Borehole", "Prepaid", "Valve Control", "Non Valve", "Abstraction", "Commercial"];

  //meter details
 useEffect(() => {
  const fetchMeterDetails = async () => {
    try {
      const res = await fetch(`${IP_URL}/meter/admin-meter-data?imei=${imei}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await res.json();
      setMeterDetails(data.meter);
 
    } catch (error) {
      console.error("Error fetching meter data", error);
    }
  };

  if (imei && token) {
    fetchMeterDetails();
  }
}, [token, imei]);


  // Fetch meter data
  useEffect(() => {
    const fetchMeter = async () => {
      const toastId = toast.loading("Fetching meter data...");
      try {
        const res = await fetch(`${IP_URL}/currentData/device-current-data?imei=${imei}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("Failed to fetch meter data");

        const data = await res.json();
        const result = data?.data || data;

        setMeter(result);
        toast.update(toastId, {
          render: "Meter data loaded successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      } catch (err) {
        console.error(err);
        toast.update(toastId, {
          render: "Error loading meter data",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      }
    };
    fetchMeter();
  }, [imei, token]);

  const fetchOrganizations = async () => {
    try {
      const res = await fetch(`${IP_URL}/organization/all-orgs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setOrganizations(data || []);
      toast.info("Organizations loaded.", { position: "bottom-left" });
    } catch (err) {
      console.error(err);
      toast.error("Failed to load organizations.");
    }
  };

  const handleShare = async () => {
    if (!selectedOrg) {
      toast.warning("Please select an organization first.");
      return;
    }

    const toastId = toast.loading("Sharing meter...");
    try {
      const res = await fetch(`${IP_URL}/organization/share-meter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          meterId: imei,
          orgUniqueKey: selectedOrg,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.update(toastId, {
          render: "Meter shared successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setShowModal(false);
      } else {
        throw new Error(data.message || "Failed to share meter.");
      }
    } catch (err) {
      toast.update(toastId, {
        render: err.message,
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  if (!meter) return <p style={{ textAlign: "center" }}>Loading meter details...</p>;




// Function to update meter info
const updateMeterInfo = async () => {
  const toastId = toast.loading("Updating meter...");
  try {
    const res = await fetch(`${IP_URL}/meter/update-meter`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        meterId: imei,
        ...editMeterData,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to update meter");

    setMeterDetails(editMeterData);
    setShowEditModal(false);
    toast.update(toastId, {
      render: "Meter updated successfully!",
      type: "success",
      isLoading: false,
      autoClose: 2000,
    });
  } catch (err) {
    toast.update(toastId, {
      render: err.message,
      type: "error",
      isLoading: false,
      autoClose: 2000,
    });
  }
};

  const batteryStatusLabel = {
    0: "OK",
    1: "Charging",
    2: "Fully Charged",
    3: "Damaged",
    4: "Low Battery",
  }[meter.batteryStatus];

  const deviceTypeLabel = {
    1: "Water Meter",
    2: "Gas Meter",
    3: "Heat Meter",
    4: "Electricity Meter",
  }[meter.deviceType];

  const flowStatus = meter.meteringErrorStatus === 0 ? "OK" : "Error";

  const formatDateTime = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return date.toLocaleString();
  };

  return (
    <Page>
      <Navbar />
      <Container>
        <Header>
          <h2>Meter Details</h2>
          <p>IMEI: {meter.imei}</p>
        </Header>

        <Section>
          <OrgButton onClick={() => { fetchOrganizations(); setShowModal(true); }}>
            Share with Organization
          </OrgButton>
          <OrgButton>Add Water Source</OrgButton>
<OrgButton
  onClick={() => {
    setEditMeterData({
      meterName: meterDetails.meterName || "",
      MSISDN: meterDetails.MSISDN || "",
      meterType: meterDetails.meterType || "",
      meterSize: meterDetails.meterSize || "",
      permitNo: meterDetails.permitNo || "",
    });
    setShowEditModal(true);
  }}
>
  Edit Meter Info
</OrgButton>
<OrgButton onClick={() => navigate(`/meter-details/${imei}`)}>View Consumption</OrgButton>

        </Section>

        {/* Share Modal */}
        <ModalOverlay show={showModal}>
          <ModalContent>
            <ModalTitle>Share Meter with Organization</ModalTitle>
            <Dropdown value={selectedOrg} onChange={(e) => setSelectedOrg(e.target.value)}>
              <option value="">Select Organization</option>
              {organizations.map((org) => (
                <option key={org.uniqueKey} value={org.uniqueKey}>
                  {org.userName}
                </option>
              ))}
            </Dropdown>
            <ActionButton onClick={handleShare}>Share</ActionButton>
            <ActionButton cancel onClick={() => setShowModal(false)}>
              Cancel
            </ActionButton>
          </ModalContent>
        </ModalOverlay>


{/* Edit Meter Modal */}

<ModalOverlay show={showEditModal}>
  <ModalContent>
    <ModalTitle>Edit Meter Info</ModalTitle>

    {/* Meter Name */}
    <div style={{ marginBottom: "12px" }}>
      <label>Meter Name</label>
      <input
        type="text"
        value={editMeterData.meterName}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, meterName: e.target.value }))
        }
        style={{ width: "100%", padding: "10px", marginTop: "5px", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>

{/**Serial No */}
  <div style={{ marginBottom: "12px" }}>
      <label>Serial No</label>
      <input
        type="text"
        value={editMeterData.serialNumber}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, serialNumber: e.target.value }))
        }
        style={{ width: "100%", padding: "10px", marginTop: "5px", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>

    {/* MSISDN */}
    <div style={{ marginBottom: "12px" }}>
      <label>MSISDN</label>
      <input
        type="text"
        value={editMeterData.MSISDN}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, MSISDN: e.target.value }))
        }
        style={{ width: "100%", padding: "10px", marginTop: "5px", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>

    {/* Meter Type */}
    <div style={{ marginBottom: "12px" }}>
      <label>Meter Type</label>
      <Dropdown
        value={editMeterData.meterType}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, meterType: e.target.value }))
        }
      >
        <option value="">Select Meter Type</option>
        {typeOptions.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </Dropdown>
    </div>

    {/* Meter Size */}
    <div style={{ marginBottom: "12px" }}>
      <label>Meter Size</label>
      <Dropdown
        value={editMeterData.meterSize}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, meterSize: e.target.value }))
        }
      >
        <option value="">Select Meter Size</option>
        {sizeOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </Dropdown>
    </div>

    {/* Permit No */}
    <div style={{ marginBottom: "12px" }}>
      <label>Permit No</label>
      <input
        type="text"
        value={editMeterData.permitNo}
        onChange={(e) =>
          setEditMeterData((prev) => ({ ...prev, permitNo: e.target.value }))
        }
        style={{ width: "100%", padding: "10px", marginTop: "5px", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>

    {/* Action Buttons */}
 <ActionButton onClick={updateMeterInfo}>Save Changes</ActionButton>
    <ActionButton cancel onClick={() => setShowEditModal(false)}>
      Cancel
    </ActionButton>
  </ModalContent>
</ModalOverlay>




        {/* Meter Info Cards */}
        <CardGrid>
          {/* Device Info */}
          <Card>
            <CardHeader>Device Info</CardHeader>
            <ItemRow><Label>Serial No:</Label><Value>{meter.serialNo}</Value></ItemRow>
            <ItemRow><Label>Module Name:</Label><Value>{meter.moduleName}</Value></ItemRow>
            <ItemRow><Label>Device Type:</Label><Value>{deviceTypeLabel}</Value></ItemRow>
            <ItemRow><Label>Hardware Ver:</Label><Value>{meter.hardwareVersion}</Value></ItemRow>
            <ItemRow><Label>Software Ver:</Label><Value>{meter.softwareVersion}</Value></ItemRow>
          </Card>

          {/**Meter Info */}
          <Card>
            <CardHeader>Meter Info</CardHeader>
            <ItemRow><Label>Meter Name:</Label><Value>{meterDetails.meterName}</Value></ItemRow>
            <ItemRow><Label>Meter Size:</Label><Value>{meterDetails.meterSize}</Value></ItemRow>         
            <ItemRow><Label>Meter Type:</Label><Value>{meterDetails.meterType}</Value></ItemRow>      
              <ItemRow><Label>permitNo:</Label><Value>{meterDetails.permitNo}</Value></ItemRow>      
            <ItemRow><Label>MSISDN:</Label><Value>{meterDetails.MSISDN}</Value></ItemRow>
          </Card>
          {/* Power & Status */}
          <Card>
            <CardHeader>Power & Status</CardHeader>
            <ItemRow><Label>Voltage:</Label><Value>{(meter.powerVoltage / 100).toFixed(2)} V</Value></ItemRow>
            <ItemRow><Label>Battery:</Label><StatusBadge status={batteryStatusLabel}>{batteryStatusLabel}</StatusBadge></ItemRow>
            <ItemRow><Label>Metering Status:</Label><StatusBadge status={flowStatus}>{flowStatus}</StatusBadge></ItemRow>
          </Card>

          {/* Flow & Readings */}
          <Card>
            <CardHeader>Flow & Readings</CardHeader>
            <ItemRow><Label>Real Flow Rate:</Label><Value>{meter.realFlowRate} L/h</Value></ItemRow>
            <ItemRow><Label>Meter Reading:</Label><Value>{(meter.meterReading / 1000).toLocaleString()} m³</Value></ItemRow>
            <ItemRow><Label>Positive Flow:</Label><Value>{(meter.positiveCumulativeFlow / 1000).toLocaleString()} m³</Value></ItemRow>
            <ItemRow><Label>Reverse Flow:</Label><Value>{(meter.reverseCumulativeFlow / 1000).toLocaleString()} m³</Value></ItemRow>
          </Card>

          {/** Valve Status */}
          {meter.valveType === 1 && (
            <Card>
            <CardHeader>Valve Status</CardHeader>
            <ItemRow><Label>Valve Status: </Label><Value style={{color : meter.valveControlStatus === 1 ? 'red' : 'green'}}>{meter.valveControlStatus === 1 ? 'Closed' : 'Open'}</Value></ItemRow>
            <ItemRow><Label>Force Control Valve:</Label><Value>{meter.forceControlValve}</Value></ItemRow>
            <ItemRow><Label>Valve Fault Status:</Label><Value style={{color: meter.valveFaultStatus === 0 ? 'green' : 'red'}}>{meter.valveFaultStatus === 0 ? 'OK' : 'Error'}</Value></ItemRow>
          </Card>
          )}

          {/* Alarms */}
          <Card>
            <CardHeader>Alarms</CardHeader>
            <ItemRow><Label>Overflow Alarm:</Label><Value>{meter.overflowAlarm ? "Triggered" : "Normal"}</Value></ItemRow>
            <ItemRow><Label>Reverse Flow Alarm:</Label><Value>{meter.reverseFlowAlarm ? "Triggered" : "Normal"}</Value></ItemRow>
            <ItemRow><Label>Magnetic Attack:</Label><Value>{meter.magneticAttackStatus ? "Detected" : "None"}</Value></ItemRow>
            <ItemRow><Label>Fault Code:</Label><Value>{meter.ultrasonicFaultCode}</Value></ItemRow>
          </Card>

          {/* Timing Info */}
          <Card>
            <CardHeader>Timing</CardHeader>
            <ItemRow><Label>Reporting period:</Label> <Value>{meter.reportingPeriod} S</Value></ItemRow>
            <ItemRow><Label>Time Zone:</Label><Value>{meter.timeZone}</Value></ItemRow>
            <ItemRow>
              <Label>Latest Reading:</Label>
              <Value>{formatDateTime(meter.createdAt)?.toString() || "—"}</Value>
            </ItemRow>
            <ItemRow>
              <Label>Updated At:</Label>
              <Value>{formatDateTime(meter.updatedAt)?.toString() || "—"}</Value>
            </ItemRow>
          </Card>
         <Card>
  <CardHeader>Network</CardHeader>

  {/* RSRP (signal strength in dBm) */}
  <ItemRow>
    <Label>RSRP</Label>
    {(() => {
      const rsrp = meter?.returnCommand?.dev?.[5]?.[11];
      let color = 'gray';
      let status = 'N/A';

      if (typeof rsrp === 'number') {
        if (rsrp > -800) {
          color = 'green';
          status = 'Excellent';
        } else if (rsrp > -900) {
          color = 'limegreen';
          status = 'Good';
        } else if (rsrp > -1000) {
          color = 'orange';
          status = 'Fair';
        } else {
          color = 'red';
          status = 'Weak';
        }
      }

      return (
        <Value style={{ color, fontWeight: 'bold' }}>
          {rsrp ? `${rsrp} dBm (${status})` : 'N/A'}
        </Value>
      );
    })()}
  </ItemRow>

  {/* SNR (signal-to-noise ratio in dB) */}
  <ItemRow>
    <Label>SNR</Label>
    {(() => {
      const snr = meter?.snr;
      let color = 'gray';
      let status = 'N/A';

      if (typeof snr === 'number') {
        if (snr >= 20) {
          color = 'green';
          status = 'Excellent';
        } else if (snr >= 13) {
          color = 'limegreen';
          status = 'Good';
        } else if (snr >= 5) {
          color = 'orange';
          status = 'Fair';
        } else {
          color = 'red';
          status = 'Poor';
        }
      }

      return (
        <Value style={{ color, fontWeight: 'bold' }}>
          {snr ? `${snr} dB (${status})` : 'N/A'}
        </Value>
      );
    })()}
  </ItemRow>
</Card>

          <Card>

            {/** Other */}
            <CardHeader>Other</CardHeader>
            <ItemRow><Label>Prepaid Balance</Label><Value style={{
              color: meter.availableWaterBalance ? 'green' : 'red',
           
            }}>  {meter.availableWaterBalance === null
      ? 'None'
      : `${meter.availableWaterBalance} L`}</Value></ItemRow>
            <ItemRow><Label>Over Draft Water</Label><Value style={{
              color: meter.overdraftWaterAmount ? 'green' : 'red',
             
            }}>{meter.overdraftWaterAmount === false ? 'Active' : 'None'}</Value></ItemRow>
          </Card>
        </CardGrid>
      </Container>
      <Footer />
    </Page>
  );
};

export default AdminMeterDetail;
